<div class="datetime-selector">
  <app-datepicker
    [selectedDate]="dateSelect"
    [disabled]="isDisabled"
    [isPopup]="true"
    [isFixedDropdown]="true"
    [includeResponsive]="true"
    (modelChange)="changeSelectTime('date', $event)"
    #datePicker
  >
  </app-datepicker>

  <div class="time-box">
    <label class="spen-mod-select">
      <select
        class="select"
        (change)="changeSelectTime('hour', $event.target.value)"
        [value]="hourSelect"
        (focus)="onTimeFocus()"
        [disabled]="isDisabled"
      >
        @for (item of [].constructor(24); track $index; let i = $index) {
          <option class="select-option" value="{{ i }}">
            {{ format2Digit(i) }}
          </option>
        }
      </select>
      <i class="fa fa-caret-down"></i>
    </label>
    <span>：</span>
    <label class="spen-mod-select">
      <select
        class="select"
        (change)="changeSelectTime('minute', $event.target.value)"
        [value]="minuteSelect"
        (focus)="onTimeFocus()"
        [disabled]="isDisabled"
      >
        @for (item of [].constructor(60); track $index; let i = $index) {
          @if (i % minuteSpan === 0) {
            <option class="select-option" value="{{ i }}">
              {{ format2Digit(i) }}
            </option>
          }
        }
      </select>
      <i class="fa fa-caret-down"></i>
    </label>
  </div>
</div>
